<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Merge Member
      </div>
      <button
        type="button"
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        />
      </button>
    </div>
    <div class="ac-body-container">
      <div class="ac-body-header">
        Which member do you wish to merge
        <br />
        {{ customer.firstName }}
        {{ customer.lastName }} into?
      </div>
      <div class="ac-dropdown-container">
        <SACAutoComplete
          placeholder="Search Member"
          label="label"
          :searchMethod="(search) => getCustomerList(search)"
          queryKey="defaultSearch"
          :select="(item) => selectMergeCustomer(item)"
        />
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        type="button"
        class="ac-form-button"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        type="button"
        class="ac-form-button"
        @click="setMergeMemberForm"
      >
        Submit
      </button>
    </div>
    <ProcessOverlay
      :show="loadingMergeCustomers"
      text="Loading Members"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import SACAutoComplete from '@shared/components/sac/SACAutoComplete.vue';

export default {
  name: 'MergeMember',
  components: {
    SACAutoComplete,
    ProcessOverlay,
  },
  mixins: [customerDetailMixin],
  methods: {
    async getCustomerList(q) {
      const customerList = await this.$store.dispatch('searchCustomerList', {
        defaultSearch: q,
      });
      const filteredList = customerList.filter(({ customerId }) => customerId !== this.customer.id);
      return filteredList.map((m) => {
        let label = `${m.customerId} - ${m.firstName} ${m.lastName}`;
        if (m.uid) {
          label += ` - ${m.uid}`;
        }
        return {
          ...m,
          label,
        };
      });
    },
    selectMergeCustomer(customer) {
      this.$store.dispatch('changeCustomerDetailValue', {
        field: 'selectedMergeCustomer',
        value: customer,
      });
    },
    setMergeMemberForm() {
      this.$store.dispatch('setMergeMemberForm');
    },
  },
};
</script>
